import * as DOMPurify from 'dompurify';

  const sanitize = (dirty:any)=> ({
    __html: DOMPurify.sanitize(
      dirty, 
    )
  });
  
  export const SanitizeHTML = ({ html }:{html:any}) => (
    <span className={'mouldToParent'} dangerouslySetInnerHTML={sanitize(html)} />
  );
